import { render } from "./AnimarTexto.vue?vue&type=template&id=8709df28&scoped=true"
import script from "./AnimarTexto.vue?vue&type=script&lang=js"
export * from "./AnimarTexto.vue?vue&type=script&lang=js"

import "./AnimarTexto.vue?vue&type=style&index=0&id=8709df28&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8709df28"]])

export default __exports__